import { X, Download } from 'lucide-react';
import { useStore } from '../store';

export function VideoModal() {
  const { previewUrl, setPreviewUrl } = useStore();
  
  if (!previewUrl) return null;
  
  const handleClose = () => setPreviewUrl(null);
  
  const handleDownload = async () => {
    try {
      const response = await fetch(previewUrl);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `vidclaw_${Date.now()}.mp4`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Download failed:', err);
    }
  };
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 animate-fade-in" onClick={handleClose}>
      <div className="relative max-w-4xl w-full mx-4 animate-fade-in-up" onClick={(e) => e.stopPropagation()}>
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute -top-12 right-0 p-2 rounded-lg bg-surface-2 hover:bg-surface-3 text-text-secondary hover:text-text-primary transition-all"
        >
          <X size={24} />
        </button>
        
        {/* Video container */}
        <div className="bg-surface-1 rounded-2xl overflow-hidden shadow-[var(--shadow-elevated)] border border-border">
          <div className="aspect-video bg-surface-0">
            <video
              src={previewUrl}
              controls
              autoPlay
              className="w-full h-full"
              playsInline
            >
              您的浏览器不支持视频播放
            </video>
          </div>
          
          {/* Controls */}
          <div className="px-6 py-4 flex items-center justify-between border-t border-border-subtle">
            <p className="text-sm text-text-secondary truncate max-w-xs">
              {previewUrl.split('/').pop()}
            </p>
            <button
              onClick={handleDownload}
              className="flex items-center gap-2 px-4 py-2 bg-brand-gradient hover:shadow-[var(--shadow-brand)] text-white text-sm font-medium rounded-xl transition-all hover:-translate-y-0.5"
            >
              <Download size={16} />
              下载到本地
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}